//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Multiselect from 'vue-multiselect';
export default {
  props: {
    propertyType: {
      type: String,
      default: null
    },
    transactionOther: {
      type: String,
      default: null
    },
    transaction: {
      type: String,
      default: null
    },
    interestOther: {
      type: String,
      default: null
    },
    complexity: {
      type: String,
      default: null
    },
    interest: {
      type: String,
      default: null
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    TRANSACTION(newValue, oldValue) {
      if (oldValue === 'Other') this.TRANSACTION_OTHER = null;
    },

    INTEREST(newValue, oldValue) {
      if (oldValue === 'Other') this.INTEREST_OTHER = null;
    }

  },
  computed: {
    PROPERTY_TYPE: {
      get() {
        return this.propertyType;
      },

      set(value) {
        this.$emit('propertyType', value);
      }

    },
    TRANSACTION_AMOUNT: {
      get() {
        return this.transactionAmount;
      },

      set(value) {
        this.$emit('transactionAmount', value);
      }

    },
    TRANSACTION_OTHER: {
      get() {
        return this.transactionOther;
      },

      set(value) {
        this.$emit('transactionOther', value);
      }

    },
    TRANSACTION: {
      get() {
        return this.transaction;
      },

      set(value) {
        this.$emit('transaction', value);
      }

    },
    INTEREST: {
      get() {
        return this.interest;
      },

      set(value) {
        this.$emit('interest', value);
      }

    },
    INTEREST_OTHER: {
      get() {
        return this.interestOther;
      },

      set(value) {
        this.$emit('interestOther', value);
      }

    },
    COMPLEXITY: {
      get() {
        return this.complexity;
      },

      set(value) {
        this.$emit('complexity', value);
      }

    }
  },
  components: {
    Multiselect
  }
};